/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CourseEnrollmentResult,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Course Enrollment
 */
export const createCourseEnrollment = (
    courseId: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);

      return axiosClient<CourseEnrollmentResult>(
      {url: `/courses/${courseId}/enrollment`, method: 'POST', signal
    },
      );
    }




export const getCreateCourseEnrollmentMutationKey = () => ['createCourseEnrollment'] as const;

export const getCreateCourseEnrollmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseEnrollment>>, TError,CreateCourseEnrollmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCourseEnrollment>>, TError,CreateCourseEnrollmentMutationVariables, TContext> => {

const mutationKey = getCreateCourseEnrollmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseEnrollment>>, CreateCourseEnrollmentMutationVariables> = (props) => {
          const {courseId} = props ?? {};

          return  createCourseEnrollment(courseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseEnrollment>>>

    export type CreateCourseEnrollmentMutationError = ErrorType<SchemaValidationErrorResponse | void | StandardError>
    export type CreateCourseEnrollmentMutationVariables = {courseId: number}

    /**
 * @summary Create Course Enrollment
 */
export const useCreateCourseEnrollment = <TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseEnrollment>>, TError,CreateCourseEnrollmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCourseEnrollment>>,
        TError,
        CreateCourseEnrollmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCourseEnrollmentMutationOptions(options), queryClient);
    }
